import { LazyLoad } from 'app/utils';

export const ShopFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.ShopFormPage,
);
